import { Box } from "@mui/material";
import Section from "./Section.jsx";
import CertificateImage from "../assets/certificate.jpg";
import LogoSvg from "../assets/logo-gold.svg";
import StudySvg from "../assets/study.svg";

export default function Education() {
  return (
    <Section
      id="education"
      title="Освіта"
      headerStyles={{
        color: "#5f2e20",
        textDecoration: "underline",
        textDecorationColor: "#ffd700",
        ":after": { display: "none" },
        mt: 6,
      }}
    >
      <Box
  sx={{
    maxWidth: 900,
    mx: "auto",
    pt: 2,
    px: 2,
    pb: 6,
    position: "relative", // 👈 важливо
  }}
>
  {/* top-left decoration */}
  <Box
    component="img"
    src={StudySvg}
    alt="decoration"
    sx={{
      position: "absolute",
      top: 25,
      left: 25,
      width: 25,
      opacity: 0.8,
      pointerEvents: "none",
    }}
  />

  <Box
    component="img"
    src={LogoSvg}
    alt="decoration"
    sx={{
      position: "absolute",
      bottom: 50,
      right: 25,
      width: 25,
      opacity: 0.8,
      pointerEvents: "none",
    }}
  />

  <Box
    sx={{
      background: "#fff",
      borderRadius: "24px",
      padding: 3,
      boxShadow: "0 12px 40px rgba(0,0,0,0.15)",
    }}
  >
    <Box
      component="img"
      src={CertificateImage}
      alt="Certificate"
      sx={{
        width: "100%",
        display: "block",
        borderRadius: "16px",
        boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
        objectFit: "cover",
      }}
    />
  </Box>
</Box>
    </Section>
  );
}